/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CoreCompany, CorePerson } from "@mm-products/java-multima-framework";
import { CorePaymentOfferDto } from "@mm-products/java-multima-framework";

export type TaxLicenceDto = {
    readonly _permissions?: Array<string>;
    company?: CoreCompany;
    created?: string;
    creator?: string;
    creatorId?: string;
    credit?: number;
    id?: string;
    modified?: string;
    modifier?: string;
    modifierId?: string;
    originalCreator?: string;
    originalCreatorId?: string;
    originalModifier?: string;
    originalModifierId?: string;
    responsiblePerson?: CorePerson;
    valid?: boolean;
    approvalAllowed?: boolean;
    itemsAllowed?: boolean;
    centreSharesAllowed?: boolean;
    status?: TaxLicenceDto.status;
    tariff?: CorePaymentOfferDto;
    subscriptionPaymentMethod?: TaxLicenceDto.paymentMethod;
    trialEndDate?: string;
    activationDate?: string;
    subscriptionVariableSymbol?: string;
    currentPeriodCreditsUsed?: number;
    terminationIssuedDate?: string;
    terminationFromDate?: string;
    terminationToDate?: string;
    terminationReason?: TaxLicenceDto.terminationReason;
};

export namespace TaxLicenceDto {
    export enum status {
        TRIAL = "TRIAL",
        ACTIVATION_PENDING = "ACTIVATION_PENDING",
        ACTIVE = "ACTIVE",
        TERMINATED = "TERMINATED",
        NEW = "NEW",
    }

    export enum paymentMethod {
        BANK_TRANSFER = "BANK_TRANSFER",
        TAX_CARD_ONE_TIME = "TAX_CARD_ONE_TIME",
        TAX_CARD_RECURRING = "TAX_CARD_RECURRING",
    }

    export enum terminationReason {
        TERMINATED_IN_TRIAL = "TERMINATED_IN_TRIAL",
        TERMINATED_IN_ACTIVE = "TERMINATED_IN_ACTIVE",
        ACTIVATION_UNPAID = "ACTIVATION_UNPAID",
        RENEWAL_UNPAID = "RENEWAL_UNPAID",
        TRIAL_EXPIRED = "TRIAL_EXPIRED",
        DEFAULT = "DEFAULT",
    }
}
